import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content for safe rendering in web chat
 * Allows only Telegram-supported HTML tags
 */
export const sanitizeHtml = (html: string): string => {
  // Configure DOMPurify with Telegram's supported HTML tags
  const cleanHtml = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      // Text formatting
      'b',
      'strong',
      'i',
      'em',
      'u',
      'ins',
      's',
      'strike',
      'del',
      // Code
      'code',
      'pre',
      // Links
      'a',
      // Structure
      'blockquote',
      'br',
      'p',
      // Lists (from markdown)
      'ul',
      'ol',
      'li',
    ],
    ALLOWED_ATTR: [
      'href', // for <a> tags
      'target', // for <a> tags to open in new tab
      'rel', // for <a> tags noopener noreferrer
      'class', // for <code> blocks with language
    ],
    // Only allow safe URI schemes explicitly
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|#)/i,
  });

  // Add target="_blank" and rel="noopener noreferrer" to all links
  const div = document.createElement('div');
  div.innerHTML = cleanHtml;
  div.querySelectorAll('a[href]').forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });

  return div.innerHTML;
};
